/**
 * Titanoré pan buy-box — mixed sizes, packs of 1–3.
 * Only on the 3 Chef's Pan PDPs (snippet gated in Liquid).
 */
(function () {
  const root = document.getElementById('tl-pan-buybox');
  if (!root) return;

  document.querySelectorAll('.okh-buns, .okh-bun-label').forEach((el) => {
    el.style.display = 'none';
  });

  let catalog = {};
  try {
    catalog = JSON.parse(root.dataset.catalog || '{}');
  } catch (e) {
    return;
  }

  const sizeOrder = ['small', 'medium', 'large'].filter((k) => catalog[k]);
  if (!sizeOrder.length) return;

  const defaultSize =
    root.dataset.defaultSize && catalog[root.dataset.defaultSize]
      ? root.dataset.defaultSize
      : sizeOrder.includes('medium')
        ? 'medium'
        : sizeOrder[0];

  const DISCOUNT = { 1: 0, 2: 0.05, 3: 0.1 };
  const choices = {
    1: [defaultSize],
    2: [defaultSize, defaultSize],
    3: [defaultSize, defaultSize, defaultSize],
  };
  let currentQty = 1;

  const moneyFormat = root.dataset.moneyFormat || '€{{amount}}';
  const packs = [...root.querySelectorAll('.tl-pack')];
  const priceNow = root.querySelector('[data-price-now]');
  const priceWas = root.querySelector('[data-price-was]');
  const priceOff = root.querySelector('[data-price-off]');
  const cta = root.querySelector('[data-cta]');

  function currentLang() {
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        return Weglot.getCurrentLang();
      }
    } catch (e) {}
    const m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : 'en';
  }

  function applyI18n() {
    const key = currentLang() === 'nl' ? 'nl' : 'en';
    root.querySelectorAll('[data-en][data-nl]').forEach((el) => {
      const next = el.getAttribute('data-' + key) || el.getAttribute('data-en');
      if (next != null) el.textContent = next;
    });
  }

  function euro(cents) {
    return '€' + Math.round(cents / 100);
  }

  function totals(qty) {
    const sizes = choices[qty];
    const unitSum = sizes.reduce((s, k) => s + catalog[k].price, 0);
    const listSum = sizes.reduce((s, k) => s + (catalog[k].compare || catalog[k].price), 0);
    const now = Math.round(unitSum * (1 - DISCOUNT[qty]));
    return { now, was: listSum, save: listSum - now };
  }

  function buildSlots(packEl, qty) {
    const host = packEl.querySelector('[data-slots]');
    if (!host) return;
    host.innerHTML = '';
    for (let i = 0; i < qty; i++) {
      const row = document.createElement('div');
      row.className = 'tl-slot';

      const label = document.createElement('div');
      label.className = 'tl-slot-label';
      label.textContent = qty === 1 ? (currentLang() === 'nl' ? 'Maat' : 'Size') : (currentLang() === 'nl' ? 'Pan ' : 'Pan ') + (i + 1);

      const grid = document.createElement('div');
      grid.className = 'tl-slot-sizes';
      grid.setAttribute('role', 'radiogroup');

      sizeOrder.forEach((key) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tl-size-btn';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', choices[qty][i] === key ? 'true' : 'false');
        btn.setAttribute('data-wg-notranslate', '');
        btn.setAttribute('translate', 'no');
        btn.textContent = catalog[key].label || catalog[key].short || key;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          choices[qty][i] = key;
          render();
        });
        grid.appendChild(btn);
      });

      row.append(label, grid);
      host.appendChild(row);
    }
  }

  function ctaLabel(amountCents) {
    const nl = currentLang() === 'nl';
    const base = nl ? 'In winkelwagen' : 'Add to cart';
    return base + ' — ' + euro(amountCents);
  }

  function render() {
    packs.forEach((pack) => {
      const qty = Number(pack.dataset.qty);
      const t = totals(qty);
      const saveEl = pack.querySelector('[data-save]');
      const nowEl = pack.querySelector('[data-now]');
      const wasEl = pack.querySelector('[data-was]');
      if (saveEl) {
        const nl = currentLang() === 'nl';
        saveEl.textContent =
          qty === 1
            ? (nl ? `${euro(t.save)} onder adviesprijs` : `${euro(t.save)} off list`)
            : (nl ? `${euro(t.save)} onder adviesprijs` : `${euro(t.save)} off list`);
      }
      if (nowEl) nowEl.textContent = euro(t.now);
      if (wasEl) wasEl.textContent = euro(t.was);
      buildSlots(pack, qty);
    });

    const selected = totals(currentQty);
    if (priceNow) priceNow.textContent = euro(selected.now);
    if (priceWas) priceWas.textContent = euro(selected.was);
    if (priceOff) {
      priceOff.textContent =
        currentLang() === 'nl' ? `${euro(selected.save)} onder adviesprijs` : `${euro(selected.save)} off list`;
    }
    if (cta) cta.textContent = ctaLabel(selected.now);
    applyI18n();
    // CTA label overrides i18n (includes live price)
    if (cta) cta.textContent = ctaLabel(selected.now);
  }

  packs.forEach((pack) => {
    const top = pack.querySelector('.tl-pack-top');
    if (!top) return;
    top.addEventListener('click', (e) => {
      e.preventDefault();
      packs.forEach((p) => p.setAttribute('aria-checked', 'false'));
      pack.setAttribute('aria-checked', 'true');
      currentQty = Number(pack.dataset.qty);
      render();
    });
  });

  async function addToCart(e) {
    e.preventDefault();
    if (!cta) return;
    cta.disabled = true;
    const prev = cta.textContent;
    cta.textContent = currentLang() === 'nl' ? 'Bezig…' : 'Adding…';

    const items = choices[currentQty].map((sizeKey) => ({
      id: Number(catalog[sizeKey].variantId),
      quantity: 1,
    }));

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('Cart add failed');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.theme && typeof window.theme.refreshCart === 'function') {
        window.theme.refreshCart();
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      cta.textContent = currentLang() === 'nl' ? 'Opnieuw proberen' : 'Try again';
      cta.disabled = false;
      setTimeout(() => {
        cta.textContent = prev;
      }, 2000);
      return;
    }
  }

  if (cta) cta.addEventListener('click', addToCart);

  function bindWeglot() {
    if (window.Weglot && typeof Weglot.on === 'function') {
      Weglot.on('languageChanged', render);
      return true;
    }
    return false;
  }
  if (!bindWeglot()) {
    let n = 0;
    const t = setInterval(() => {
      n += 1;
      if (bindWeglot() || n > 40) clearInterval(t);
    }, 100);
  }

  render();
})();
